import { Channel } from 'stream-chat'

// Reads state.membership (own role), not state.members: the members map is truncated on large channels.
export function isChannelMember(channel: Channel) {
  return channel.state.membership?.channel_role === "channel_member"
}

export function isChannelOwner(channel: Channel, streamUserId: string) {
  return channel.data?.owner_id?.toString() === streamUserId.toString()
}

export function getChannelTourRequest(channel: Channel) {
  return {
    tourRequestId: channel.data?.tour_request_id ?? "",
    tourRequestName: channel.data?.tour_request_name ?? "",
  }
}
